import { render, staticRenderFns } from "./PageTopbarSection.vue?vue&type=template&id=4fd4c408&"
import script from "./PageTopbarSection.vue?vue&type=script&lang=js&"
export * from "./PageTopbarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports